import React from "react";
import DifficultyMenu from "./DifficultyMenu";
import GameContainer from "./GameContainer";
import GameOverComponent from "./GameOverComponent";
import { usePokemonMemory } from "../context/PokemonMemoryContext";

const PokemonMemoryGameInner = () => {
  const { gameState } = usePokemonMemory();
  return (
    <div className="text-center min-h-screen bg-gradient-to-br from-indigo-100 to-purple-100 py-8">
      <div>
        <h1 className="text-5xl font-bold text-purple-600 mb-8">Pokemon Memory Game</h1>
        <DifficultyMenu />
        {gameState.difficulty !== "" && !gameState.isGameOver && (
          <GameContainer difficulty={gameState.difficulty} />
        )}
        {gameState.isGameOver && <GameOverComponent />}
      </div>
    </div>
  );
};

export default PokemonMemoryGameInner;
